module.exports = __webpack_public_path__ + "static/media/Bg3.9c18e495.jpg";